(() => {
  const form = document.getElementById('CaldrisLanguage');
  const script = document.querySelector('script[data-caldris-currency]');
  if (!form || !script) return;
  const language = form.elements.language_code;
  const country = form.elements.country_code;
  const market = () => language.value === 'fr'
    ? { country: 'FR', currency: 'EUR' }
    : { country: 'US', currency: 'USD' };
  const applyMarket = () => { country.value = market().country; };
  form.addEventListener('submit', applyMarket);
  language.addEventListener('change', () => {
    applyMarket();
    form.submit();
  });
  // Direct visits to /fr or / must agree with the language selector too.
  // A one-attempt guard prevents reload loops if a market becomes unavailable.
  const key = `caldris-market:${location.pathname}:${market().currency}`;
  if (script.dataset.caldrisCurrency === market().currency) {
    try { sessionStorage.removeItem(key); } catch (_) { /* Storage may be disabled. */ }
    return;
  }
  if (script.dataset.caldrisDesignMode === 'true') return;
  try {
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
  } catch (_) {
    // The explicit selector remains usable when session storage is unavailable.
    return;
  }
  applyMarket();
  form.submit();
})();
